import { useFrame } from "@react-three/fiber";
import { useRef } from "react";
import { Center, Text3D } from "@react-three/drei";
import { animated } from "@react-spring/three";
import Star from "../meshes/Stars/Star";
import { useAtomValue, useAtom } from "jotai";
import { turnAtom, languageAtom } from "../GlobalState";
import { formatName } from "../logicHelpers/helpers";
import translations from '../dictionaries/translations';

export default function TimesUpAlert({ scale=1, position }) {
    const [language] = useAtom(languageAtom);
    const fontUrl = language === 'korean' ? "/fonts/Maplestory_Bold.json" : language === 'chinese' ? "/fonts/Xiao Xiangjiao font_Regular.json" : "/fonts/Luckiest Guy_Regular.json";

    return <animated.group scale={scale} position={position}>
        <mesh
            castShadow
            receiveShadow
            scale={[2.6, 0.055, 2]}
        >
            <cylinderGeometry args={[1, 1, 1, 64]}/>
            <meshStandardMaterial color='black' opacity={0.8} transparent/>
        </mesh>
        <Center position={[0, 0.2, 0]} key={Math.random()}>
            <Text3D
                font={fontUrl}
                rotation={[Math.PI/2, Math.PI, Math.PI]}
                size={0.7}
                height={0.01}
                lineHeight={0.8}
            >
                {translations.alerts.timesUp[language]}
                <meshStandardMaterial color='red'/>
            </Text3D>
        </Center>
    </animated.group>
}